var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Scanner"},[_c('canvas',{attrs:{"id":"scannerCanvas"}}),_c('input',{staticClass:"ZoomControl",attrs:{"type":"range","id":"zoomRange","disabled":""}})])
}]

export { render, staticRenderFns }